import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { useFetcher } from '../useGetFetchConfig';

interface ProcessingDocsResponse {
  docIds: string[];
  hasActiveRun: boolean;
}

export const useGetProcessingDocs = (matterId: string | null) => {
  const fetcher = useFetcher();

  return useQuery<ProcessingDocsResponse>(
    [QueryEntity.ProcessingDocs, { matterId }],
    () => fetcher(`${APIBaseChronos}/api/matters/${matterId}/processing-docs`),
    {
      enabled: !!matterId,
      refetchInterval: 10000, // Poll every 10 seconds
      refetchOnWindowFocus: true,
    },
  );
};
